import { isVelaStatus } from '../listings/statuses';

import { NEW } from '../../constants/product';

export function shouldAddPlaceholder({ product, status }) {
  const channel = product.get('channel');
  const productId = product.get('productId');
  return (
    productId === NEW || (
      isVelaStatus({ channel, status: product.get('status') }) && !isVelaStatus({ channel, status })
    )
  );
}
